// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPriorPlanYearDto } from './IPriorPlanYearDto';
import {
    IPriorPlanYearDtoFromJSON,
    IPriorPlanYearDtoFromJSONTyped,
    IPriorPlanYearDtoToJSON,
    IPriorPlanYearDtoToJSONTyped,
} from './IPriorPlanYearDto';
import type { IAuditActor } from './IAuditActor';
import {
    IAuditActorFromJSON,
    IAuditActorFromJSONTyped,
    IAuditActorToJSON,
    IAuditActorToJSONTyped,
} from './IAuditActor';

/**
 * 
 * @export
 * @interface IPlanYearDto
 */
export interface IPlanYearDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanYearDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanYearDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearDto
     */
    valid_from?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearDto
     */
    valid_to?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanYearDto
     */
    prior_plan_year_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanYearDto
     */
    is_first_plan_year?: boolean;
    /**
     * 
     * @type {IPriorPlanYearDto}
     * @memberof IPlanYearDto
     */
    prior_plan_year?: IPriorPlanYearDto;
    /**
     * 
     * @type {IAuditActor}
     * @memberof IPlanYearDto
     */
    audit_actor?: IAuditActor;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearDto
     */
    update_source?: IPlanYearDtoUpdateSourceEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPlanYearDtoUpdateSourceEnum {
    FILE = 'FILE',
    API = 'API',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    USER_PORTAL = 'USER_PORTAL'
}


/**
 * Check if a given object implements the IPlanYearDto interface.
 */
export function instanceOfIPlanYearDto(value: object): value is IPlanYearDto {
    return true;
}

export function IPlanYearDtoFromJSON(json: any): IPlanYearDto {
    return IPlanYearDtoFromJSONTyped(json, false);
}

export function IPlanYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanYearDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : json['valid_from'],
        'valid_to': json['valid_to'] == null ? undefined : json['valid_to'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'prior_plan_year_id': json['prior_plan_year_id'] == null ? undefined : json['prior_plan_year_id'],
        'is_first_plan_year': json['is_first_plan_year'] == null ? undefined : json['is_first_plan_year'],
        'prior_plan_year': json['prior_plan_year'] == null ? undefined : IPriorPlanYearDtoFromJSON(json['prior_plan_year']),
        'audit_actor': json['audit_actor'] == null ? undefined : IAuditActorFromJSON(json['audit_actor']),
        'update_source': json['update_source'] == null ? undefined : json['update_source'],
    };
}

export function IPlanYearDtoToJSON(json: any): IPlanYearDto {
    return IPlanYearDtoToJSONTyped(json, false);
}

export function IPlanYearDtoToJSONTyped(value?: IPlanYearDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'name': value['name'],
        'valid_from': value['valid_from'],
        'valid_to': value['valid_to'],
        'organization_path': value['organization_path'],
        'prior_plan_year_id': value['prior_plan_year_id'],
        'is_first_plan_year': value['is_first_plan_year'],
        'prior_plan_year': IPriorPlanYearDtoToJSON(value['prior_plan_year']),
        'audit_actor': IAuditActorToJSON(value['audit_actor']),
        'update_source': value['update_source'],
    };
}

